import decodeToken from 'jwt-decode'

class TokenValidator {
  isTokenActive(token: any): boolean {
    const decoded: any = decodeToken(token)
    const now = Date.now().valueOf() / 1000
    if (typeof decoded.exp !== 'undefined' && decoded.exp < now) {
      throw new Error('token expired')
    }
    if (typeof decoded.nbf !== 'undefined' && decoded.nbf > now) {
      throw new Error('token not yet valid')
    }
    return true
  }
}

export default new TokenValidator()
